import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';

function Form() {
    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/obras-projects/save`,
        endpointGetById: `${endpointBackend}gci/obras-projects/getById`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        urlGoBack: `/gci/obras-projects/list`,
        pathView: `/gci/obras-projects/view`
    }

    const labels = {
        labelTitleAdd: "Vincular Obra ao Projeto",
        labelTitleEdit: "Editar Vínculo Obra x Projeto",
        labelTitleView: "Visualizar Vínculo Obra x Projeto"
    }

    const getForm = (values) => {
        let form = {
            fields: [
                {
                    name: 'nome_obra',
                    type: 'text',
                    label: 'Obra',
                    validations: {
                        required: false
                    },
                    disabled: true,
                    readOnly: true,
                    columnSize: 12
                },
                {
                    name: 'gci_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, []);

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
